// A limit or override change is always saved, but copying it to checkout can fail
// (the backend flags that with an X-Checkout-Sync: failed header). Checkout would
// then keep using the old rule, so the merchant is told to save again rather than
// shown a plain success message.
export const CHECKOUT_SYNC_FAILED_MESSAGE =
  "Saved, but checkout couldn't be updated. Please try again.";

export function savedMessage(response, successMessage) {
  return response?.headers?.['x-checkout-sync'] === 'failed'
    ? CHECKOUT_SYNC_FAILED_MESSAGE
    : successMessage;
}
